import { useEffect } from "react";
import { useMutation } from "@apollo/client";
import { ChatHeartbeatMutation, ChatLeaveMutation } from "@/entities/contents";
import type {
  ChatHeartbeatMutationType,
  ChatLeaveMutationType,
} from "@/types/graphql/site.generated";

const HEARTBEAT_INTERVAL_MS = 30_000;

// Фоновые heartbeat/leave-вызовы происходят без явного пользовательского
// клика на каждый тик таймера — тихо проглатываем ошибку (без unhandled
// rejection), не показывая snackbar на каждую фоновую неудачу (это было бы
// навязчиво, в отличие от явных действий вроде отправки/удаления сообщения).
function ignoreBackgroundError(): void {
  // no-op: intentional silent catch, see comment above
}

export function useChatHeartbeat(chatRoomId: string | null): void {
  const [heartbeat] = useMutation<ChatHeartbeatMutationType>(
    ChatHeartbeatMutation,
  );
  const [leave] = useMutation<ChatLeaveMutationType>(ChatLeaveMutation);

  useEffect(() => {
    if (!chatRoomId) return undefined;

    void heartbeat({ variables: { chatRoomId } }).catch(ignoreBackgroundError);
    const interval = setInterval(() => {
      void heartbeat({ variables: { chatRoomId } }).catch(
        ignoreBackgroundError,
      );
    }, HEARTBEAT_INTERVAL_MS);

    return () => {
      clearInterval(interval);
      void leave({ variables: { chatRoomId } }).catch(ignoreBackgroundError);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chatRoomId]);
}
